import styled, { css } from 'styled-components/macro';

export const ContentWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 1246px;
  max-width: 100%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 50px;
`;

export const Content = styled(ContentWrapper)`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  width: 1200px;
  padding-bottom: 0;
`;

export const VideosList = styled.div<{ minHeight?: string }>`
  width: 100%;
  min-height: ${props => props.minHeight || '530px'};
`;

export const Video = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid rgb(223, 227, 230);
`;

export const VideoPlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const VideoThumbnailWrapper = styled.div`
  position: relative;
  width: 60px;
  height: 40px;
  border-radius: 5px;
  background: ${props => props.theme.colors.black[100]};
  cursor: pointer;
  overflow: hidden;
`;

export const BaseModalText = styled.div`
  height: 24px;
  margin-left: 24px;
  font-size: 16px;
  line-height: 1.5;
  text-align: left !important;
  color: ${props => props.theme.colors.black[100]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const BaseHeaderText = styled(BaseModalText)`
  font-size: 14px;
  color: ${props => props.theme.colors.black[60]};
  display: flex;
`;

// vehicle year
export const VehicleYearWidth = css`
  max-width: 80px;
  min-width: 80px;
`;
export const VehicleYear = styled(BaseModalText)`
  ${VehicleYearWidth}
`;

export const VehicleYearHeader = styled(BaseHeaderText)`
  ${VehicleYearWidth}
`;
// vehicle make
export const VehiclePlaylistWidth = css`
  max-width: 100px;
  min-width: 100px;
`;
export const VehiclePlaylist = styled(BaseModalText)`
  ${VehiclePlaylistWidth}
`;
export const VehiclePlaylistHeader = styled(BaseHeaderText)`
  ${VehiclePlaylistWidth}
`;

// checbox
export const CheckboxPreviewWidth = css`
  min-width: 40px;
  max-width: 40px;
`;
export const CheckboxPreview = styled.div`
  ${CheckboxPreviewWidth}
`;
export const CheckboxPreviewHeader = styled(BaseHeaderText)`
  margin-left: 0;
  ${CheckboxPreviewWidth}
`;

// vehicle preview
export const VehiclePreviewWidth = css`
  min-width: 80px;
  max-width: 80px;
`;
export const VehiclePreview = styled.div`
  ${VehiclePreviewWidth}
`;
export const VehiclePreviewHeader = styled(BaseHeaderText)`
  margin-left: 0;
  ${VehiclePreviewWidth}
`;
// vehicle library
export const VehicleLibraryWidth = css`
  min-width: 100px;
  max-width: 100px;
`;
export const VehicleLibrary = styled(BaseModalText)`
  ${VehicleLibraryWidth}
`;
export const VehicleLibraryHeader = styled(BaseHeaderText)`
  ${VehicleLibraryWidth}
`;

// vehicle model
export const VehicleModelWidth = css`
  max-width: 180px;
  min-width: 180px;
`;
export const VehicleModel = styled(BaseModalText)`
  ${VehicleModelWidth}
`;

export const VehicleModelHeader = styled(BaseHeaderText)`
  ${VehicleModelWidth}
`;

// vehicle title
export const VehicleTitleWidth = css`
  width: inherit;
`;
export const VehicleTitle = styled(BaseModalText)`
  ${VehicleTitleWidth}
  cursor: default;
`;

export const VehicleTitleHeader = styled(BaseHeaderText)`
  ${VehicleTitleWidth}
`;

export const EmptySearch = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  min-height: 530px;
`;

export const Footer = styled(ContentWrapper)`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  padding-bottom: 0;
`;
